import type { JobDetails } from "@/domain/model/JobDetails";
import type { JobDetailsService } from "@/domain/port/JobDetailsService";
import { HttpClient } from "@/infrastructure/HttpClient";
import type { JobDetailsResponse } from "./dto/JobDetailsDto";
import type { JobId } from "@/domain/model/Ids";
import { jobDetailsFromDto } from "./mappers/JobDetailsMapper";

export class JobDetailsServiceImpl implements JobDetailsService {
  constructor(private readonly http: HttpClient) {}

  async getJobDetails(jobId: JobId): Promise<JobDetails> {
    const resp = await this.http.request<JobDetailsResponse>(
      `/api/jobs/${jobId}/details`,
      {
        method: "GET",
      },
    );

    try {
      return jobDetailsFromDto(resp);
    } catch (mappingError) {
      console.error(
        `[DataMapper Error] Failed to parse JobDetails ${jobId}`,
        mappingError,
      );
      console.dir(resp);
      throw new Error(`Invalid data received from server for Job ${jobId}`);
    }
  }
}
